import React from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import { Rating } from "@aqar-app/aqar-design-system";
import styles from "./reviewItem.module.scss";

const ReviewItem = ({ created_time, rate, comment }) => {
  return (
    <div className={styles.reviewItem}>
      <div className={styles.top}>
        <Rating value={rate} />
        <span className={styles.date}>
          <span>{dayjs(created_time * 1000).format("DD/MM/YY")}</span>
        </span>
      </div>
      <div>
        <p className={styles.comment}>{comment}</p>
      </div>
    </div>
  );
};

ReviewItem.propTypes = {
  created_time: PropTypes.number.isRequired,
  rate: PropTypes.number.isRequired,
  comment: PropTypes.string.isRequired,
};

export default ReviewItem;
